import Headline, { type Props } from "./Headline";

export default function H3({size = "xl", ...props}:Props) {
  return <Headline tag="h3" size={size} {...props}/>;
}